import { settings } from '@springtree/eva-sdk-core-settings';
import { SETTINGS_GROUP_NAME } from '@springtree/eva-sdk-core-service';
import { atom } from 'recoil';
import storage, { safeParseInt } from '../../helpers/storage.js';
import { storageKey as endpointStorageKey } from './eva-endpoint-url-state.js';
const storageKey = 'evaRequestedOrganizationUnitID';
// This atom is used to focus service calls on a certain organization unit
// using an ID.
// It will automatically be added to service calls manager by the state
// builders in this SDK or can be used for manual calls
//
const requestedOrganizationUnitIdState = atom({
    key: 'evaRequestedOrganizationUnitId',
    default: safeParseInt(storage.getItem(storageKey) || ''),
    effects: [
        ({ setSelf, onSet }) => {
            // Set initial value from storage
            //
            setSelf(safeParseInt(storage.getItem(storageKey) || ''));
            // Update storage on change
            //
            onSet((newValue, oldValue, isReset) => {
                if (newValue !== oldValue) {
                    isReset || !newValue
                        ? storage.removeItem(storageKey)
                        : storage.setItem(storageKey, `${newValue}`);
                }
            });
            // Listen for updates applied through local storage
            // Not that storage events are only triggered from other tabs/windows
            // If you update the storage in the active window itself there will be no trigger
            //
            if (globalThis.addEventListener) {
                globalThis.addEventListener('storage', (storageEvent) => {
                    /* istanbul ignore next */
                    switch (storageEvent.key) {
                        case storageKey:
                            {
                                if (storageEvent.newValue !== storageEvent.oldValue) {
                                    setSelf(storageEvent.newValue ? safeParseInt(storageEvent.newValue) : undefined);
                                }
                            }
                            break;
                        case endpointStorageKey:
                            {
                                // Changes to the endpoint warrant this atom being unset
                                //
                                if (storageEvent.newValue !== storageEvent.oldValue) {
                                    setSelf(undefined);
                                    storage.removeItem(storageKey);
                                }
                            }
                            break;
                        default:
                            {
                                // NOOP
                            }
                            break;
                    }
                });
            }
            // Listen for updates coming from the @springtree/eva-sdk-core-service
            //
            settings.subscribe({
                channel: `eva.setting.${SETTINGS_GROUP_NAME}.requestedOrganizationUnitID`,
                callback: ({ value }) => {
                    storage.setItem(storageKey, value.new || '');
                    setSelf(safeParseInt(value.new || ''));
                },
            });
        },
    ],
});
export default requestedOrganizationUnitIdState;
//# sourceMappingURL=requested-organization-unit-id-state.js.map